import { useState } from "react"

export default function FaqSection({
  title = "Frequently Asked Questions",
  desc = "Find answers to common questions.",
  faqs = [],
}) {
  const [openIndex, setOpenIndex] = useState(0)

  if (!faqs.length) return null

  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-5 sm:px-8">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
            {title}
          </h2>

          <p className="mx-auto mt-3 max-w-[640px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
            {desc}
          </p>
        </div>

        <div className="mx-auto max-w-[1200px] space-y-5">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index

            return (
              <div
                key={`${item.question}-${index}`}
                className={`rounded-xl bg-white px-5 py-5 shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all duration-500 ease-in-out sm:px-7 ${
                  isOpen
                    ? "sm:mx-0 shadow-[0_14px_35px_rgba(0,0,0,0.14)]"
                    : "sm:mx-12"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-start gap-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="min-w-[34px] text-sm font-semibold text-black/80">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="flex-1 text-sm font-bold text-black sm:text-[15px]">
                    {item.question}
                  </span>

                  <span
                    className={`text-xl leading-none text-black transition-transform duration-500 ease-in-out ${
                      isOpen ? "rotate-45" : "rotate-0"
                    }`}
                  >
                    +
                  </span>
                </button>

                <div
                  className={`grid transition-[grid-template-rows] duration-500 ease-in-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p
                      className={`ml-[50px] mt-3 max-w-[620px] text-xs leading-relaxed text-gray-600 transition-all duration-500 ease-in-out sm:text-sm ${
                        isOpen
                          ? "translate-y-0 opacity-100"
                          : "-translate-y-2 opacity-0"
                      }`}
                    >
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}